import React from "react";
import { Row, Col, Form, OverlayTrigger, Tooltip, Badge, Button } from "react-bootstrap";
import { Building2 } from "lucide-react";
import { EductionCell, SkillsCell } from "../../student-profile/student-grid-view";
import Resume from "../../resume";
import { showStatusMsg } from "../../../utils/utils";
import { maskStatus } from "../../../utils/maskContactInfo";

const StudentApplicationGrid = ({
    student,
    selectedStudents,
    toggleStudentSelection,
    statusButtons,
    confirmStatusChange,
    isDisabled,
    DisabledMessage,
    openHistoryModal,
    confirmStatusToHired,
}) => {
    const disabledStatuses = ["accept", "hired", "offer_accept", "offer_declined", "rejected", "cancelled", "offer_sent"];
    const showTooltip = disabledStatuses.includes(student.status);

    return (
        <div key={student.id} className="col-xl-4 col-lg-6 col-md-6 mb-4">
            <div className="card-body padnone">
                <div style={{ position: "relative" }}>
                    <div className="gallery-box card fillcolor" style={{ padding: 0 }}>
                        <div className="card mb-0 yellowborder" >
                            <div className="card-body" style={{ padding: 15 }}>
                                <div className="position-absolute" style={{ top: "25px", right: "20px" }}>
                                    {showTooltip ? (
                                        <OverlayTrigger
                                            placement="top"
                                            overlay={
                                                <Tooltip id={`tooltip-${student.id}`}>
                                                    {DisabledMessage(student?.status)}
                                                </Tooltip>
                                            }
                                        >
                                            <span className="d-inline-block">
                                                <Form.Check
                                                    type="checkbox"
                                                    className="rounded-circle"
                                                    checked={selectedStudents.has(student.id)}
                                                    onChange={() => toggleStudentSelection(student.id)}
                                                    disabled={student.status === "accept" || student.status === "hired" || student.status === "offer_sent" || student.status === "cancelled" || student.status === "rejected" || student.status === "offer_accept" ? true : false}
                                                />
                                            </span>
                                        </OverlayTrigger>
                                    ) : (
                                        <span className="d-inline-block">
                                            <Form.Check
                                                type="checkbox"
                                                className="rounded-circle"
                                                checked={selectedStudents.has(student.id)}
                                                onChange={() => toggleStudentSelection(student.id)}
                                                disabled={student.status === "accept" || student.status === "hired" || student.status === "offer_sent" || student.status === "cancelled" || student.status === "rejected" || student.status === "offer_accept" ? true : false}
                                            />
                                        </span>
                                    )}
                                </div>

                                <div className="d-flex align-items-center justify-content-between mb-3">
                                    <div className="d-flex align-items-center">
                                        <div
                                            className="bg-primary rounded-circle d-flex align-items-center justify-content-center me-3 text-white fw-bold"
                                            style={{ width: "44px", height: "39px", fontSize: "14px" }}
                                        >
                                            {student.name
                                                .split(" ")
                                                .map((n) => n[0])
                                                .join("")}
                                        </div>
                                        <div>
                                            <h6 className="card-title mb-1 fw-bold">{student.name}</h6>
                                            <small className="text-muted schoolaname" style={{ height: "30px" }}>{student.college}</small>
                                        </div>
                                    </div>
                                </div>
                                <hr />

                                <div className="mb-3 p-2 bg-light rounded">
                                    <div className="d-flex align-items-center">
                                        <i className="bi bi-briefcase me-2 text-primary"></i>
                                        <strong className="text-primary">
                                            <span className="text-dark">Job Title : </span>
                                            {student.position}
                                        </strong>
                                    </div>
                                </div>

                                <Row className="g-3 mb-3">
                                    <Col xs={6}>
                                        <div className="d-flex align-items-center">
                                            <i className="bi bi-geo-alt me-2 text-muted" style={{ fontSize: "14px" }}></i>
                                            <div>
                                                <small className="text-muted d-block" style={{ fontSize: "11px", lineHeight: "1.2" }}>
                                                    Location
                                                </small>
                                                <span style={{ fontSize: "13px", fontWeight: "500" }}>{student.location}</span>
                                            </div>
                                        </div>
                                    </Col>
                                    <Col xs={6}>
                                        <div className="d-flex align-items-center">
                                            <i className="bi bi-telephone me-2 text-muted" style={{ fontSize: "12px" }}></i>
                                            <div>
                                                <small className="text-muted d-block" style={{ fontSize: "11px", lineHeight: "1.2" }}>
                                                    Phone No.
                                                </small>
                                                <small style={{ fontSize: "12px" }}>
                                                    {maskStatus.includes(student.status)
                                                        ? student.phone
                                                        : student.phone}
                                                </small>
                                            </div>
                                        </div>
                                    </Col>
                                </Row>

                                <div className="mb-3">
                                    <div className="d-flex align-items-center mb-2">
                                        <i className="bi bi-envelope me-2 text-muted" style={{ fontSize: "12px" }}></i>
                                        <small style={{ fontSize: "12px" }}>
                                            {maskStatus.includes(student.status)
                                                ? student.email
                                                : student.email}
                                        </small>
                                    </div>
                                    
                                </div>
                                <div className="d-flex align-items-center text-muted mb-2">
                                    <i className="bi bi-calendar3 me-2" style={{ fontSize: "12px" }}></i>
                                    <small style={{ fontSize: "11px" }}>
                                        Applied{" "}
                                        {new Date(student.appliedDate).toLocaleDateString("en-US", {
                                            month: "short",
                                            day: "numeric",
                                            year: "numeric",
                                        })}
                                    </small>
                                </div>
                                <div className="mb-2">
                                    <small className="text-muted d-block mb-2 text-uppercase fw-semibold" style={{ fontSize: 11, letterSpacing: "0.5px" }}>
                                        Education
                                    </small>
                                    <div className="d-flex flex-wrap gap-1">
                                        <EductionCell eductionList={student.degreeTitle} numShow={3} isGrid={true} studentEdu={student?.eduArr || []}/>
                                    </div>
                                </div>

                                <div className="mb-2">
                                    <small className="text-muted d-block mb-2 text-uppercase fw-semibold" style={{ fontSize: 11, letterSpacing: "0.5px" }}>
                                        Skills
                                    </small>
                                    <div className="d-flex flex-wrap gap-1">
                                        <SkillsCell skillsCsv={student?.skills} numShow={3} isApp={true} />
                                    </div>
                                </div>

                                <div className="mb-2">
                                    <p className="mr-1 d-block mb-2 " style={{ fontSize: 11, letterSpacing: "0.5px" }}>
                                        <span className="text-uppercase fw-semibold text-muted ">Current Status: {" "} </span><span className="text-capitalize text-dark " style={{ fontSize: 12, letterSpacing: "0.5px" }}>
                                            {showStatusMsg[student.status?.toLowerCase()] ||
                                                (student.status
                                                    ? student.status.charAt(0).toUpperCase() + student.status.slice(1)
                                                    : "")
                                            }
                                        </span>
                                    </p>
                                </div>

                                <div className="mb-2" style={{ borderRadius: 12 }}>
                                    <div className="d-flex gap-1">
                                        {statusButtons.map(({ key, text, active, outline, fontSize, padding }) => {
                                            const isBtnDisabled = isDisabled(student.status, key);
                                            const shouldShowTooltip = isBtnDisabled && disabledStatuses.includes(student.status);
                                            const button = (
                                                <button
                                                    key={key}
                                                    className={`btn btn-sm flex-fill w-100 ${isBtnDisabled && "text-decoration-line-through"} ${student.status === key ? active : outline}`}
                                                    onClick={() => confirmStatusChange(student.id, key, student)}
                                                    style={{ fontSize, fontWeight: "500", padding }}
                                                    disabled={isBtnDisabled}
                                                >
                                                    {text}
                                                </button>
                                            );
                                            if (shouldShowTooltip) {
                                                return (
                                                    <OverlayTrigger
                                                        key={key}
                                                        placement="top"
                                                        overlay={
                                                            <Tooltip id={`tooltip-${student.id}`}>
                                                                {DisabledMessage(student?.status)}
                                                            </Tooltip>
                                                        }
                                                    >
                                                        <span className="w-100">{button}</span>
                                                    </OverlayTrigger>
                                                );
                                            }

                                            return <span key={key} className="w-100">{button}</span>;
                                        })}
                                    </div>
                                </div>

                                <div className="d-flex gap-1">
                                    {student.status === "hired" &&
                                        <Button className="w-100" size="sm" onClick={() => confirmStatusToHired(student.id, "hired", student)}>
                                            Send Offer
                                        </Button>
                                    }
                                    <Resume isStidentList={true} id={student?.student_id} />
                                </div>

                                <div className="mt-2">
                                    <button
                                        className={`btn btn-sm flex-fill btn-outline-dark w-100`}
                                        onClick={() => openHistoryModal(student)}
                                        style={{ fontSize: "12px", fontWeight: "500", padding: "6px 12px" }}
                                    >
                                        View History
                                    </button>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default StudentApplicationGrid;